export const UserIdTypes = {
  ADMIN: 1,
}
